// extracted by mini-css-extract-plugin
export var fullWidthButton = "_qe-0";